import { type ReactNode, useState } from 'react';
import type { DayBucket } from '../utils/chart-buckets';
import { chartTone, TONE_BAR, TONE_GLOW } from '../utils/chart-color';

function fmtTip(iso: string): string {
  return new Date(iso + 'T12:00:00').toLocaleDateString('es-ES', {
    day: 'numeric',
    month: 'short',
  });
}

function Tip({ bucket }: { bucket: DayBucket }): ReactNode {
  return (
    <div className="pointer-events-none absolute bottom-full right-0 z-40 mb-1.5 min-w-max rounded-lg bg-surface-elevated px-2.5 py-1.5 shadow-lg">
      <p className="text-[11px] font-medium text-text-primary">
        {fmtTip(bucket.date)}
      </p>
      <p className="font-mono text-[10px] tabular-nums text-text-tertiary">
        {bucket.count} creators
      </p>
    </div>
  );
}

function barStyle(
  pct: number,
  hover: boolean,
  glow: string
): React.CSSProperties {
  return {
    height: `${pct}%`,
    minHeight: pct > 0 ? 3 : 0,
    boxShadow: hover ? `0 0 6px ${glow}` : 'none',
  };
}

export function ChartBar({
  bucket,
  maxH,
}: {
  bucket: DayBucket;
  maxH: number;
}): ReactNode {
  const [hover, setHover] = useState(false);
  const pct = maxH > 0 ? (bucket.count / maxH) * 100 : 0;
  const tone = chartTone(bucket.count);
  return (
    <div
      className="relative flex h-full w-2 shrink-0 items-end"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div
        className={`w-full rounded-t ${TONE_BAR[tone]} transition-all duration-150 hover:brightness-125`}
        style={barStyle(pct, hover, TONE_GLOW[tone])}
      />
      {hover && bucket.count > 0 && <Tip bucket={bucket} />}
    </div>
  );
}
